export const $ScrollLockModuleName = "scrollLock";

export type TScrollLockState = {
    lockedDiscriminators: string[];
};
